
export const formatNumber = (number)=> Number(number).toLocaleString();
export const formatShortenNumber = (number) =>{
    const n = Number(number);
    if(n > 10000000){
        return formatNumber(Math.round(n/1000000))+"mio"
    } else if(n > 100000){
        return formatNumber(Math.round(n/1000))+"k"
    }
    return formatNumber(number);
}